import request from './request'

// 管理员登录
export function adminLogin (data) {
  return request({
    url: '/admin/login',
    method: 'post',
    data
  })
}

export function getAdminProfile () {
  return request({
    url: '/admin/profile',
    method: 'get'
  })
}

export function updateAdminProfile (data) {
  return request({
    url: '/admin/profile/update',
    method: 'post',
    data
  })
}

export function updateAdminPassword (data) {
  return request({
    url: '/admin/profile/password',
    method: 'post',
    data
  })
}

export function getLoginBackground () {
  return request({
    url: '/admin/login/background',
    method: 'get'
  })
}

// 获取轮播图列表
export function getBannerList () {
  return request({
    url: '/admin/banner',
    method: 'get'
  })
}

// 添加轮播图
export function addBanner (data) {
  return request({
    url: '/admin/banner/add',
    method: 'post',
    data
  })
}

// 更新轮播图
export function updateBanner (data) {
  return request({
    url: '/admin/banner/update',
    method: 'post',
    data
  })
}

// 删除轮播图
export function deleteBanner (id) {
  return request({
    url: `/admin/banner/delete/${id}`,
    method: 'delete'
  })
}

// 获取商品分类列表（分页）
export function getCategoryList (params) {
  return request({
    url: '/admin/category/page',
    method: 'get',
    params
  })
}

// 获取所有商品分类列表
export function getAllCategories () {
  return request({
    url: '/admin/category/list',
    method: 'get'
  })
}

// 添加商品分类
export function addCategory (data) {
  return request({
    url: '/admin/category/add',
    method: 'post',
    data
  })
}

// 更新商品分类
export function updateCategory (data) {
  return request({
    url: '/admin/category/update',
    method: 'post',
    data
  })
}

// 删除商品分类
export function deleteCategory (id) {
  return request({
    url: '/admin/category/delete',
    method: 'post',
    data: { id }
  })
}

export function getUserPage (params) {
  return request({
    url: '/admin/user/page',
    method: 'get',
    params
  })
}

export function getUserDetail (id) {
  return request({
    url: `/admin/user/${id}`,
    method: 'get'
  })
}

export function updateUser (data) {
  return request({
    url: '/admin/user/update',
    method: 'post',
    data
  })
}

export function deleteUser (id) {
  return request({
    url: '/admin/user/delete',
    method: 'post',
    data: { id }
  })
}

// 获取商品列表
export function getProductList (params) {
  return request({
    url: '/admin/product/list',
    method: 'get',
    params
  })
}

// 获取商品详情
export function getProductDetail (id) {
  return request({
    url: '/admin/product/detail',
    method: 'get',
    params: { id }
  })
}

// 添加商品
export function addProduct (data) {
  return request({
    url: '/admin/product/add',
    method: 'post',
    data
  })
}

// 更新商品
export function updateProduct (data) {
  return request({
    url: '/admin/product/update',
    method: 'post',
    data
  })
}

// 删除商品
export function deleteProduct (id) {
  return request({
    url: '/admin/product/delete',
    method: 'post',
    params: { id }
  })
}

// 获取订单列表（分页，支持按状态/订单号筛选）
export function getOrderList (params = {}) {
  return request({
    url: '/admin/order/list',
    method: 'get',
    params
  })
}

// 获取订单详情
export function getOrderDetail (orderId) {
  return request({
    url: '/admin/order/detail',
    method: 'get',
    params: { orderId }
  })
}

// 更新订单状态
export function updateOrderStatus (data) {
  return request({
    url: '/admin/order/updateStatus',
    method: 'post',
    data
  })
}

// 修改运单号，不改变订单状态
export function updateOrderTrackingNumber (orderId, trackingNumber) {
  return request({
    url: '/admin/order/trackingNumber',
    method: 'post',
    params: { orderId, trackingNumber }
  })
}

// 查询快递轨迹和地图。收件地址 to 有值时后端会返回地图链接
export function queryKuaidiTrack (params) {
  return request({
    url: '/user/kuaidi/query',
    method: 'get',
    params,
    timeout: 20000
  })
}

// 管理员审核退款（执行微信退款，到账后无需等待回调）
export function adminRefund (orderId, adminPhone) {
  return request({
    url: '/admin/order/adminRefund',
    method: 'post',
    params: { orderId, adminPhone },
    timeout: 20000
  })
}

// 向微信核对单笔订单是否已支付
export function syncAdminPay (orderId) {
  return request({
    url: '/admin/order/syncPay',
    method: 'post',
    params: { orderId },
    timeout: 20000
  })
}

// 向微信核对单笔订单退款是否到账
export function syncAdminRefund (orderId) {
  return request({
    url: '/admin/order/syncRefund',
    method: 'post',
    params: { orderId },
    timeout: 20000
  })
}

// 核对全部待确认的支付和退款
export function syncAdminWechat () {
  return request({
    url: '/admin/order/syncWechat',
    method: 'post',
    timeout: 60000
  })
}

// 导出订单（支持按条件筛选）
export function exportOrders (params = {}) {
  return request({
    url: '/admin/order/export',
    method: 'get',
    params,
    timeout: 60000 // 导出接口设置60秒超时，不受全局5秒限制
  })
}

// 上传客服二维码
export function uploadCustomerServiceQR (file) {
  const formData = new FormData()
  formData.append('file', file)
  return request({
    url: '/admin/common/upload/customer-service-qr',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 获取客服二维码
export function getCustomerServiceQR () {
  return request({
    url: '/admin/common/customer-service-qr',
    method: 'get'
  })
}

// 删除客服二维码
export function deleteCustomerServiceQR () {
  return request({
    url: '/admin/common/customer-service-qr',
    method: 'delete'
  })
}

// ============ DIY材料管理 ============

// 获取DIY材料列表
export function getDiyMaterialList (params) {
  return request({
    url: '/admin/diy/material/list',
    method: 'get',
    params
  })
}

// 获取DIY材料详情
export function getDiyMaterialDetail (id) {
  return request({
    url: `/admin/diy/material/${id}`,
    method: 'get'
  })
}

// 添加DIY材料
export function addDiyMaterial (data) {
  return request({
    url: '/admin/diy/material',
    method: 'post',
    data
  })
}

// 更新DIY材料
export function updateDiyMaterial (data) {
  return request({
    url: '/admin/diy/material',
    method: 'put',
    data
  })
}

// 删除DIY材料
export function deleteDiyMaterial (id) {
  return request({
    url: `/admin/diy/material/${id}`,
    method: 'delete'
  })
}

// 批量更新DIY材料状态
export function updateDiyMaterialStatus (status, ids) {
  return request({
    url: `/admin/diy/material/status/${status}`,
    method: 'post',
    data: ids
  })
}

// 获取色系列表
export function getColorSeriesList () {
  return request({
    url: '/admin/diy/material/colorSeries/list',
    method: 'get'
  })
}

// ============ 设计广场管理 ============

// 分页查询设计广场作品列表（含已隐藏）
// params: { page, size, plazaVisible, keyword }
export function getDesignPlazaList (params = {}) {
  return request({
    url: '/admin/design/plaza/list',
    method: 'get',
    params
  })
}

// 设置某条作品在设计广场的展示开关（0隐藏 1展示）
export function setDesignPlazaVisibility (id, plazaVisible) {
  return request({
    url: '/admin/design/plaza/visibility',
    method: 'post',
    params: { id, plazaVisible }
  })
}

export function getDesignPhotos (bizType, bizId) {
  return request({
    url: '/admin/design/plaza/photos',
    method: 'get',
    params: { bizType, bizId }
  })
}

export function saveDesignPhotos (data) {
  return request({
    url: '/admin/design/plaza/photos',
    method: 'post',
    data
  })
}

export function getDesignerPage (params) {
  return request({
    url: '/admin/designer/page',
    method: 'get',
    params
  })
}

export function getDesignerDetail (id) {
  return request({
    url: `/admin/designer/${id}`,
    method: 'get'
  })
}

export function auditDesigner (data) {
  return request({
    url: '/admin/designer/audit',
    method: 'post',
    data
  })
}

export function updateDesignerProfile (data) {
  return request({
    url: '/admin/designer/update',
    method: 'post',
    data
  })
}

export function saveDesignerWork (data) {
  return request({
    url: '/admin/designer/work/save',
    method: 'post',
    data
  })
}

export function deleteDesignerWork (id) {
  return request({
    url: '/admin/designer/work/delete',
    method: 'post',
    data: { id }
  })
}

export function getHomePoster () {
  return request({
    url: '/admin/home/poster',
    method: 'get'
  })
}

export function saveHomePoster (data) {
  return request({
    url: '/admin/home/poster',
    method: 'post',
    data
  })
}

export function getHomeNotice () {
  return request({
    url: '/admin/home/notice',
    method: 'get'
  })
}

export function saveHomeNotice (data) {
  return request({
    url: '/admin/home/notice',
    method: 'post',
    data
  })
}

export function getHomeMusic () {
  return request({
    url: '/admin/home/music',
    method: 'get'
  })
}

export function saveHomeMusic (data) {
  return request({
    url: '/admin/home/music',
    method: 'post',
    data
  })
}

export function getDiyStudioAdmin () {
  return request({
    url: '/admin/design/studio',
    method: 'get'
  })
}

export function saveDiyTray (data) {
  return request({
    url: '/admin/design/studio/tray',
    method: 'post',
    data
  })
}

export function deleteDiyTray (id) {
  return request({
    url: '/admin/design/studio/tray',
    method: 'delete',
    params: { id }
  })
}

export function saveConfirmPoster (data) {
  return request({
    url: '/admin/design/studio/poster',
    method: 'post',
    data
  })
}

export function saveDiySound (data) {
  return request({
    url: '/admin/design/studio/sound',
    method: 'post',
    data
  })
}

export function getOrderAddons () {
  return request({
    url: '/admin/order/addon/list',
    method: 'get'
  })
}

export function saveOrderAddon (data) {
  return request({
    url: '/admin/order/addon',
    method: 'post',
    data
  })
}

export function deleteOrderAddon (id) {
  return request({
    url: '/admin/order/addon',
    method: 'delete',
    params: { id }
  })
}
